<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- CARD PRINCIPALE DI CONTENIMENTO DELLA PAGINA -->
    <b-card :title="page_title" class="mr-1 ml-1">
      <!-- HEADER SUPERIORE -->
      <!--
      <b-row>
        <b-col class='header-subtitle mt-2 pt-2 pb-2' cols="12">
          <h3 class='text-center'>Massimizza i tuoi risparmi</h3>
          <h5 class='text-center'>Il portale Convenzioni Welfarebit è stato progettato per offrire il massimo valore: che si stia cercando
            sconti su tecnologia, viaggi, tempo libero, shopping o servizi per la casa, si troverà sempre l'offerta giusta
            al momento giusto. </h5>
          <h5 class='text-center'>Non si tratta solo di risparmiare, ma di migliorare la qualità della vita quotidiana.</h5>
          <h5 class='text-center'>Gli utenti più attivi del portale riportano risparmi medi tra 500 e 1.500 euro all'anno, semplicemente
            utilizzando regolarmente le convenzioni disponibili.</h5>
        </b-col>
      </b-row>

      <b-row class='mt-2' align-h="center">
        <b-col class='text-center mb-auto mt-auto' md="8">
          <p class='text-justify promo-text-b'>
            Usufruisci di sconti, premi e gratifiche con migliaia di marche che ami in una varietà
            di categorie:
          </p>

            <b-row class='mt-2' align-h="center">
              <b-col class='text-left' cols="6">
                <ol class='promo-text-b'>
                  <li ><b>Controlla regolarmente le novità</b></li>
                  <p>Visita il portale almeno una volta a settimana per scoprire le nuove
                    offerte. Molte hanno disponibilità limitata o scadenze brevi. Attiva le
                    notifiche per restare sempre aggiornata.</p>
                </ol>
              </b-col>
              <b-col class='text-left' cols="6">
                <ol class='promo-text-b' start="2">
                  <li ><b>Pianifica i grandi acquisti</b></li>
                  <p>Prima di acquistare elettrodomestici, viaggi o servizi costosi, verifica
                    le offerte disponibili: possono garantire risparmi significativi rispetto
                    ai prezzi di mercato.</p>
                </ol>
              </b-col>
          </b-row>

          <b-row class='mt-2' align-h="center">
            <b-col class='text-left' cols="6">
              <ol class='promo-text-b' start="3">
                <li ><b>Condividi con la famiglia</b></li>
                <p>Molte convenzioni sono valide anche per i familiari. Informali delle
                  opportunità disponibili per moltiplicare i vantaggi.</p>
              </ol>
            </b-col>
            <b-col class='text-left' cols="6">
              <ol class='promo-text-b' start="4">
                <li ><b>Combina più convenzioni</b></li>
                <p>Cerca opportunità per unire diverse offerte, ad esempio hotel +
                  ristorante + attività, così da massimizzare il risparmio totale.</p>
              </ol>
            </b-col>
          </b-row>

          <b-row class='mt-2'  align-h="center" >
            <b-col class='text-left' cols="6">
              <ol class='promo-text-b' start="5">
                <li ><b> Sfrutta la stagionalità</b></li>
                <p>Le convenzioni seguono l’andamento stagionale (viaggi estivi, sport
                  invernali, ecc.). Consulta il portale con anticipo per cogliere le
                  migliori opportunità prima che si esauriscano.</p>
              </ol>
            </b-col>
            <b-col class='text-left' cols="6">
              <ol class='promo-text-b' start="6">
                <li ><b>Esplora nuove categorie</b></li>
                <p>Non limitarti ai soliti brand o servizi. Il portale offre categorie e
                  offerte inaspettate che potrebbero sorprenderti con risparmi
                  significativi.</p>
              </ol>
            </b-col>
          </b-row>
          <b-row class='text-center ' md="6" >
            <b-col class='text-center' cols="12">
              <b-img
                  :src="logos_image"
                  fluid
                  alt="logos image"
              ></b-img>
            </b-col>
          </b-row>
            -->
          <p class="h1 promo-text mt-md-3 mt-2 text-center">
            Copia il codice cliccandoci sopra:
              <b-link class="code-link" @click.prevent="copia_codice_negli_appunti">
                <b>{{benefit_hub_code}}</b>
              </b-link>
          </p>
          <p class="h4 promo-text text-center mt-3">
            Clicca nella barra blu qui sotto ed inizia a risparmiare!
          </p>
        <!-- </b-col> -->
      <!-- </b-row>-->

     <b-row>
       <b-col class='text-center pt-2 pb-2 mt-3' cols="12">
         <b-button class='subscription-button' :href="benefit_hub_site" target='_blank' block >
           <h4>Clicca qui per iscriverti</h4>
         </b-button>
       </b-col>
     </b-row>
   </b-card>

   <!-- MODALE PER IL VIDEO DA VISUALIZZARE IN APERTURA DI PAGINA -->
    <!--
    <b-modal
      v-model="show_modal"
      size='lg'
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header>
      <b-embed
          type="video"
          aspect="4by3"
          :src="video_path"
          allowfullscreen
          controls
          autoplay
      ></b-embed>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="cancel()">
          Chiudi
        </b-button>
      </template>
    </b-modal>
  -->
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'BenefitHub',
  data () {
    return {
      tagline_elem : [ { text : "Sconti grandi marchi con c/credito", link : 'benefit-hub' } ],
      page_title: "Sconti grandi marchi con c/credito",

      // Dati di benefit hub
      benefit_hub_site: 'https://welfarebit.benefitforme.com',
      benefit_hub_code: 'WELFAREBIT26',

      // Loghi
      logos_image: require('@/assets/benefit_hub/benefitsHubPartner.png'),

      // Visualizzazione della modale con il video
      show_modal : true,

      // Path del video da riprodurre:
      // Lo abbiamo scaricato con il Wistia video converter per chrome, alternativamente
      // si può riprodurre tramite il link:
      // https://fast.wistia.net/embed/iframe/7fd2d6m0s4?videoFoam=true
      // Ottenuto partendo dal link di Wistia di benefit hub seguendo questa
      // guida fino al passaggio 3:
      // https://www.yeahhub.com/download-wistia-videos-without-tool/
      // Però abbiamo visto che in mobile la riproduzione non parte, pertanto abbiamo
      // optato per il download in locale da noi.
      video_path : "https://userportal.welfarebit.it/media/tutorials/benefit_hub.mp4"

    }
  },
  methods: {
    /**
     * Copia il codice di benefit hub negli appunti creando una textarea
     * invisibile che viene aggiunta poi rimossa.
     * Una volta copiato lo notifica con un toast che poi scompare da solo.
     */
    copia_codice_negli_appunti : function () {
      // Copio
      const el = document.createElement('textarea');
      el.value = this.benefit_hub_code;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      // Notifico con toast.
      this.$bvToast.toast( 'Codice copiato negli appunti.', {
        title: 'Azione eseguita.',
        toaster: 'b-toaster-top-left',
        //solid: true,
        autoHideDelay: 1500,
        variant: 'success',
        appendToast: false
      });
    }
  },
  /**
   * All'apertura della pagina visualizziamo la modale con il video
   */
  mounted : function () {
    this.show_modal = true;
  },
  components: {
      PageTagline
  }
}
</script>


<style scoped>
.header-subtitle {
  background: #0870b9;
  color: #ffffff;
  border-radius: 10px;
}
.promo-text {
  color: #525252;
}
.promo-text-b {
  color: #525252;
  font-size: 16px;
}
.code-link {
  color: #525252;
  text-decoration: none;
}
.code-link:hover {
  color: #787878;
  text-decoration: none;
}
.subscription-button {
  background: #0870b9;
  border-color:#0870b9;
  color: #ffffff;
}
.subscription-button:hover {
  background: #0d83d6;
  border-color:#0d83d6;
}
/* Negli schermi più piccoli del desktop la lista delle categorie
   deve rimpicciolirsi */
@media (max-width: 768px) {
  .promo-text-b {
    color: #525252;
    font-size: 13px;
  }
}
</style>